module.exports = __webpack_public_path__ + "static/media/MagnifyingGlass.a33bafeb.svg";